<div class="{{navbarClass}}">
    <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" routerLink="/">
                <img src="assets/img/logo.png" alt="logo">

            </a>
            <a href="#" class="nav-link"><b>الحج المبرور للحج والعمرة</b> </a>

        </nav>
    </div>
</div>
